import React from "react";
import underconstruction from "../../../assets/images/UnderConstruction.png"
import { AlignHorizontalCenter } from "@mui/icons-material";
export default function Jobs() {
  
  return (
    <div>
  <div>  <img alt="logo" width="20%" src={underconstruction}  /></div>
    </div>
  );
}
